<template>
  <v-container>
    <v-toolbar-title v-text="$t('monitoring.process_monitoring')" />
    <Filters @findTableData="findTableData" @removeDataView="removeDataView" />
    <DataTable
      :page.sync="page"
      :items-per-page.sync="itemsPerPage"
      :loading="loading"
      :total-rows="totalRows"
      :items="listMaster"
      @findTableData="findTableData"
      @refresh="findTableData"
    />
  </v-container>
</template>
<script>
import Service from '../../../../services/MonitoringLegacyService'
import Filters from './Filters.vue'
import DataTable from './DataTable.vue'
import Utils from '../../utils'

export default {
  name: 'MonitoringLegacy',

  components: {
    Filters,
    DataTable
  },

  data: () => ({
    page: 0,
    listMaster: [],
    loading: false,
    monitoringProcesss: null,
    totalRows: 0,
    refreshItemsPerPage: true
  }),

  mounted () {
    this.findTableData()
  },

  computed: {
    itemsPerPage: {
      get () {
        // eslint-disable-next-line no-unused-vars
        const refreshItemsPerPage = this.refreshItemsPerPage // Cookies data isn't auto-recomputed!
        return this.$cookies.isKey('monitoring_per_page') ? parseInt(this.$cookies.get('monitoring_per_page')) : 10
      },
      set (value) {
        this.$cookies.set('monitoring_per_page', value)
        this.recomputeItemsPerPage()// It's to force a recompute of 'itemsPerPage' !
      }
    },
    canFindTableData () {
      const { processType, jobIdentifier, date } = this.$route.query
      return processType && jobIdentifier && date
    }
  },

  methods: {
    removeDataView () {
      this.page = 0
      this.listMaster = []
    },
    recomputeItemsPerPage () {
      this.refreshItemsPerPage = !this.refreshItemsPerPage // It's to force a recompute of 'itemsPerPage' !
    },
    findTableData () {
      if (!this.canFindTableData) {
        // console.info(this.$t('warnings.error.not_enough_data'))
        return null // Se sem parametros de url, nao realizar busca (não é erro).
      }

      const { processType, jobIdentifier, date } = this.$route.query
      const { itemsPerPage, page, formatObjectDate } = this
      this.totalRows = 0
      this.loading = true

      Service.findAll(processType, jobIdentifier, date, page, itemsPerPage)
        .then(r => {
          const { data, totalRows } = r.data
          this.listMaster = data?.map(formatObjectDate)
          this.totalRows = totalRows
        })
        .catch(err => console.error(this.$t('warnings.error.occurred'), err))
        .finally(() => { this.loading = false })
    },
    formatObjectDate (obj) {
      obj.currentDate = Utils.formatDate(obj.currentDate)
      return obj
    }
  }
}
</script>
<style>
.methodname {
  color: brown;
  font-weight: bold;
}
.classname {
  color: blue;
}
</style>
